import SvgIcon from '@mui/material/SvgIcon';
import InputIcon from '@mui/icons-material/Output';

// Google Sheets
export function GoogleSheetsIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M19 3H10.5L5 8.5V21h14V3z" fill="#34A853" />
      <rect x="8" y="10" width="8" height="1.5" fill="white" />
      <rect x="8" y="13" width="8" height="1.5" fill="white" />
      <rect x="8" y="16" width="5" height="1.5" fill="white" />
    </SvgIcon>
  );
}

// Google Drive
export function GoogleDriveIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9 3L3 13.5 6 21h6l6-10.5L12 3H9z" fill="#4285F4" />
      <path d="M12 3h3l6 10.5-3 7.5h-3L9 3h3z" fill="#34A853" />
      <path d="M3 13.5L6 21h12l-3-7.5H3z" fill="#FBBC05" />
    </SvgIcon>
  );
}

export function OutputIcon(props) { 
  return (
    <InputIcon {...props} style={{ transform: "rotate(180deg)" }} />
  );
}